import React from 'react';
import PostSource from "../../../components/pages/grid/PostSource/PostSource";

const PostSourceGridPage = () => {
    return <PostSource />
};

export default PostSourceGridPage;